<template>
    <nav v-if="getCountPage > 1">
        <ul class="pagination flex-wrap m-0 p-0 px-1 d-flex justify-content-center align-items-center">
            <template v-for="(row, index) in getCountPage">
                <li :key="index" class="page-item d-flex justify-content-center align-items-center"
                    :class="{ active: intPageNumber == (index + 1) }" aria-current="page"
                    style="min-width: 35px; max-width: 35px; text-align: center;">
                    <span class="page-link" v-if="intPageNumber == (index + 1)">{{ index + 1 }}</span>
                    <a class="page-link" v-on:click="intPageNumber = (index + 1)" v-else>{{ index + 1 }}</a>
                </li>
            </template>
            <!-- تعیین تعداد رکورد در هر صفحه -->
            <li class="page-item d-flex align-items-center mr-2" style="max-width: 65px;">
                <select class="form-control form-control-sm rounded-3" v-model="intCountRow">
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                </select>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "Pagination_" + this.Name,
    props: ["DataRepository", "Name", "CountRow"],
    watch: {
        // در لحظه تغییر در منبع اطلاعات یکبار اجرا می شود
        DataRepository: function () {
            // دریافت تعداد سطر در هر صفحه از والد
            // this.intCountRow = this.CountRow;
            // alert(this.Name + ' \ ' + this.intCountRow);
        },
    },
    data() {
        return {
            // تعداد سطرها در هر صفحه
            intCountRow: this.CountRow,
            // شماره صفحه در حال انتخاب
            intPageNumber: 1,
            // تعداد کل صفحه ها
            intCountPage: 1,
        }
    },
    created() { },
    mounted() { },
    computed: {
        // دریافت تعداد صفحات لیست
        getCountPage() {
            if (this.DataRepository != null && this.DataRepository.length > 0) {
                let intCountPageLocal = this.DataRepository.length;
                intCountPageLocal = parseInt(intCountPageLocal / this.intCountRow);
                if (this.DataRepository.length % this.intCountRow) {
                    intCountPageLocal++;
                }
                if (intCountPageLocal < this.intPageNumber) {
                    this.intPageNumber = intCountPageLocal;
                }
                this.intCountPage = parseInt(intCountPageLocal);
                // اعلام اعمال تغییرات به والد
                this.$emit("ChangePage", { countRow: this.intCountRow, pageNumber: this.intPageNumber, countPage: this.intCountPage });
                return parseInt(this.intCountPage);
            } else {
                return 1;
            }
        },
    },
    methods: {
    },
}
</script>

<style>
.pagination .page-item .page-link:hover {
    background-color: #efff6e;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/PublicComponents/Pagination.vue